import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../types/Ticket';
import * as Func from "../../utils/functions";
import {parseListRequestParams} from '../../utils/commonUtils';
import * as FunctionService from '../services/ticketService';
import * as FunctionAction from '../actions/ticketAction';
import {message} from "antd";
import TicketRequest from "../mapping/Request/TicketRequest";
import TAG_DEFINE from "../../constants/common";
import PERMISSION from "../../constants/permission";

function* actionGetListTickets() {
    yield takeLatest(Types.TICKET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(FunctionService.getListTickets, params);
        yield put(FunctionAction.ticketListSuccess(result));
    }, errorHandle(Types.TICKET_FAILED)))
}

function* actionGetItem() {
    yield takeLatest(Types.TICKET_GET_TEM_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(FunctionService.getItem, action.params.id);
        yield put(FunctionAction.ticketGetItemSuccess(result));
    }, errorHandle(Types.TICKET_FAILED)))
}

function* actionGetMasterTickets() {
    yield takeLatest(Types.TICKET_MASTER_DATA_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(FunctionService.masterData, action.params);
        yield put(FunctionAction.ticketMasterDataSuccess(result));
    }, errorHandle(Types.TICKET_FAILED)))
}

// function* createAction() {
//     yield takeLatest(Types.TICKET_CREATE_ACTION, Func.sagaWrapper(function* (action) {
//         const data = new TicketRequest(action.params).exportCreate();
//         const result = yield call(FunctionService.create, data);
//         message.success(TAG_DEFINE.VALIDATION.statusCode.code["201"]);
//         action.params.props.history.push(PERMISSION.TICKET.VIEW.route, {group: PERMISSION.TICKET.VIEW.group});
//         // yield put({ type: Types.TICKET_LIST_ACTION });
//     }, errorHandle(Types.TICKET_FAILED)))
// }

function* commentAction() {
    yield takeLatest(Types.TICKET_COMMENT_ACTION, Func.sagaWrapper(function* (action) {
        const data = new TicketRequest(action.params).exportComment();
        yield call(FunctionService.comment, data);
        message.success(TAG_DEFINE.VALIDATION.statusCode.code["204"]);
        yield put(FunctionAction.ticketGetItemAction({id: action.params.id}));
    }, errorHandle(Types.TICKET_FAILED)))
}

function* updateAction() {
    yield takeLatest(Types.TICKET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const data = new TicketRequest(action.params).exportUpdate();
        yield call(FunctionService.update, data);
        message.success(TAG_DEFINE.VALIDATION.statusCode.code["204"]);
        yield put(FunctionAction.ticketGetItemAction({id: action.params.id}));
    }, errorHandle(Types.TICKET_FAILED)))
}

function errorHandle(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({type: errorActionType, errors: e?.errors})
    });
}

export function* ticketSaga() {
    yield all([
        fork(actionGetListTickets),
        fork(actionGetMasterTickets),
        fork(actionGetItem),
        fork(updateAction),
        fork(commentAction),
    ])
}
